
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getResolveTaskChangeRequestDtoFormGroup() {
return new FormGroup({
    resolvedNotes: new FormControl<string | undefined>('', [Validators.maxLength(1000)]),
})
;
}
      